import React from 'react';
import ShareButton from './ShareButton';

const CharityDetailModal = ({ charity, isOpen, onClose }) => {
  if (!isOpen || !charity) return null;

  const formatAmount = (amount) => {
    if (!amount) return '0 VND';
    return new Intl.NumberFormat('vi-VN').format(amount) + ' VND';
  };

  const formatCount = (count) => {
    return new Intl.NumberFormat('vi-VN').format(count);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="relative">
        {/* Close Button - Next to Modal */}
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 z-10 bg-[#fe6601] hover:bg-[#e55a00] text-white hover:text-white w-10 h-10 rounded-full flex items-center justify-center text-2xl shadow-lg transition-colors duration-200"
        >
          ×
        </button>
        <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="bg-white border-b border-gray-200 p-6 rounded-t-xl">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold text-[#fe6601] mb-2">
                {charity.title}
              </h2>
              <div className="flex items-center gap-2">
                <span className="bg-[#fe6601] text-white px-3 py-1 rounded-full text-sm font-semibold">
                  #{charity.top}
                </span>
                <span className="text-sm text-gray-500">Chương trình thiện nguyện</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            {/* Image */}
            <div className="mb-6">
              <div className="relative h-64 md:h-80 rounded-lg overflow-hidden">
                <img
                  src={charity.avatarLink}
                  alt={charity.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
            </div>

            {/* Description */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-800 mb-3">Mô tả chương trình</h3>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {charity.description}
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Thống kê chương trình</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-[#fff5f0] border border-[#f9ab6b8a] rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 font-semibold">Quỹ chia sẻ</span>
                    <span className="text-xl font-bold text-[#fe6601]">
                      {formatAmount(charity.countShare * 50000 || 0)}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 mt-1">Tổng số tiền quỹ từ thiện</p>
                </div>
                <div className="bg-[#fff5f0] border border-[#f9ab6b8a] rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 font-semibold">Lượt chia sẻ</span>
                    <span className="text-xl font-bold text-[#fe6601]">
                      {formatCount(charity.countShare)} lượt
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 mt-1">Số lượt chia sẻ từ cộng đồng</p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="flex justify-center">
              <ShareButton charity={charity} className="py-3 px-8 rounded-lg text-sm">
                Chia sẻ chương trình
              </ShareButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharityDetailModal;
